import dayjs from "dayjs";
import { ActivityType } from "../../types/UserActivityInterfaces";

interface MessageInfo {
  icon: string;
  verb: string;
}

interface MessageProps {
  info: MessageInfo;
  time: string;
}

const Message = ({ info, time }: MessageProps) => {
  return (
    <div
      className="text-muted font-weight-500 d-flex align-items-center"
      style={{ fontSize: 13 }}
    >
      <i
        className={`mdi mdi-${info.icon} mr-1`}
        style={{ fontSize: 14, lineHeight: 1 }}
      ></i>
      {info.verb} {time}
    </div>
  );
};

interface MutedMessageProps {
  activityType: ActivityType;
  activityTime: string;
}

const MessageByType: { [K in ActivityType]: MessageInfo } = {
  "edited-record-in-page": { icon: "pencil", verb: "Edited" },
  "edited-dashboard-view": { icon: "pencil", verb: "Edited" },
  "queried-page-view-table": { icon: "filter", verb: "Queried" },
  "edited-page": { icon: "pencil", verb: "Edited" },
  "edited-document-view": { icon: "pencil", verb: "Edited" },
  "bulk-update-in-page": { icon: "pencil", verb: "Updated" },
  "bulk-delete-in-page": { icon: "delete", verb: "Deleted" },
  "viewed-page-view": { icon: "eye", verb: "Viewed" },
};

const MutedMessage = ({ activityType, activityTime }: MutedMessageProps) => {
  const momentFromNow = dayjs(activityTime).fromNow();

  if (!momentFromNow)
    return <small className="text-muted">Unknown time range</small>;

  return <Message info={MessageByType[activityType]} time={momentFromNow} />;
};

export default MutedMessage;
